/* eslint-disable no-redeclare */
import { z } from 'zod';

import { CostModel, HtmlText, Integer, NonEmptyText, Url } from '../primitive';

export const AdServer = z.enum([
  'FeaturedAds',
  'AdButler',
  'MediaAlpha',
  'HealthPilot',
  'NextInsure',
]);
export type AdServer = z.infer<typeof AdServer>;

export const FeaturedAd = z.object({
  id: NonEmptyText,
  logo: Url,
  title: NonEmptyText,
  content: HtmlText,
  provider: z.object({
    id: Integer.optional(),
    name: NonEmptyText,
    displayUrl: z.string(),
  }),
  link: Url,
  creativeId: Integer,
  groupId: Integer.optional(),
  campaignId: Integer.optional(),
  campaignName: NonEmptyText.optional(),
  dealType: CostModel,
  cpc: z.number(),
  adsSource: AdServer,
  searchMethod: z.string().optional(),
  segmentationFit: z.string().optional(),
  uniqueClickId: z.string().optional(),
  /** Partner pixel fired once when the ad renders (e.g. QuinStreet `imp_pixel`). */
  impressionPixelUrl: Url.optional(),
});

export type FeaturedAd = z.infer<typeof FeaturedAd>;
